import { adoptedStyle, connectStore, css, customElement, GemElement, html, mounted, numattribute } from '@mantou/gem';
import { mediaQuery } from '@mantou/gem/helper/mediaquery';
import { waitLoading } from 'duoyun-ui/elements/wait';
import { formatDuration, Time } from 'duoyun-ui/lib/time';
import { configure } from 'src/configure';
import { githubIssue } from 'src/constants';
import { i18n } from 'src/i18n/basic';
import { icons } from 'src/icons';
import { getRecord } from 'src/services/api';
import { getComments } from 'src/services/guest-api';
import { store } from 'src/store';
import { theme } from 'src/theme';
import { getGithubGames } from 'src/utils/common';

import 'duoyun-ui/elements/action-text';
import 'duoyun-ui/elements/divider';
import 'src/modules/comment-list';
import 'src/modules/game-detail';
import 'src/modules/screenshots';

const style = css`
  :scope {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    padding-inline: ${theme.gridGutter};
    padding-block-start: ${theme.gridGutter};
    gap: ${theme.gridGutter};
  }
  .screenshots::-webkit-scrollbar {
    width: 0;
  }
  .content {
    display: flex;
    flex-direction: row;
    gap: calc(3 * ${theme.gridGutter});
    margin-block: calc(${theme.gridGutter});
  }
  .aside {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-shrink: 0;
    width: 12em;
    line-height: 1.7;
  }
  .aside:where(:lang(zh), :lang(ja), :lang(kr)) {
    text-align: justify;
  }
  .stats-icon {
    gap: 0.2em;
  }
  .stats-icon::part(icon) {
    width: 1.2em;
  }
  @media ${mediaQuery.PHONE} {
    .content {
      flex-direction: column;
    }
  }
`;

@customElement('p-game')
@adoptedStyle(style)
@connectStore(store)
export class PGameElement extends GemElement {
  @numattribute gameId: number;

  get #game() {
    return store.games[this.gameId];
  }

  #edit = async () => {
    if (this.#game) {
      const { name } = this.#game;
      const links = await waitLoading(getGithubGames(name));
      const link = links.find((e) => e.textContent === name);
      if (link) {
        open(new URL(githubIssue).origin + new URL(link.href).pathname);
      } else {
        open(githubIssue);
      }
    }
  };

  @mounted()
  #init = () => {
    getComments(this.gameId);
    if (configure.user) {
      getRecord(this.gameId);
    }
  };

  render = () => {
    const record = store.record[this.gameId];

    return html`
      <m-screenshots class="screenshots" .game=${this.#game}></m-screenshots>
      <div class="content">
        <m-game-detail .game=${this.#game}></m-game-detail>
        <div class="aside">
            <dy-use v-if=${!!record} class="stats-icon" .element=${icons.date}>
              ${i18n.get('page.game.lastPlay', new Time().relativeTimeFormat(record?.lastPlayStartAt || 0))}
            </dy-use>
            <dy-use v-if=${!!record} class="stats-icon" .element=${icons.schedule}>
              ${i18n.get('page.game.totalPlay', formatDuration(record?.playTotal || 0, { precision: 'm' }))}
            </dy-use>
          <dy-use class="stats-icon" @click=${this.#edit} .element=${icons.edit}>
            <dy-action-text>${i18n.get('page.game.update')}</dy-action-text>
          </dy-use>
        </div>
      </div>
      <dy-divider></dy-divider>
      <m-comment-list .game=${this.#game}></m-comment-list>
    `;
  };
}
